import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import NavigationArrow from 'components/NavigationArrow/NavigationArrow.jsx'

import ConstructBuilding from '../ConstructBuilding/ConstructBuilding.jsx'

import styles from './ConstructCarousel.scss'

const ConstructCarousel = ({ buildings, selectedBuildingIdx, onItemClick, onItemHover }) => {
    const isFirstSlide = (selectedBuildingIdx === 0)
    const isLastSlide = (selectedBuildingIdx === (buildings.length - 1))

    const handleNextClick = () => {
        if (!isLastSlide) {
            onItemClick(selectedBuildingIdx + 1)
        }
    }

    const handlePrevClick = () => {
        if (!isFirstSlide) {
            onItemClick(selectedBuildingIdx - 1)
        }
    }

    const handleSlideItemClick = (itemIndex, isItemActive) => {
        if (!isItemActive) {
            onItemClick(itemIndex)
        }
    }

    const handleSlideItemMouseEnter = (isItemActive) => {
        if (!isItemActive) {
            onItemHover()
        }
    }

    return (
        <div className={cx(styles.base, styles[`base__selected-item-${selectedBuildingIdx}`])}>
            <div className={styles.holder}>
                <div className={styles.list}>
                    {buildings.map(({ building }, index) => {
                        const isActive = index === selectedBuildingIdx

                        return (
                            <div
                                className={cx(styles.item, isActive && styles.item__active)}
                                key={building.type}
                                onClick={() => handleSlideItemClick(index, isActive)}
                                onMouseEnter={() => handleSlideItemMouseEnter(isActive)}
                            >
                                <ConstructBuilding isActive={isActive} {...building} />
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className={cx(styles.arrow, styles.arrow__left)}>
                <NavigationArrow type='left' handleClick={handlePrevClick} disabled={isFirstSlide} />
            </div>
            <div className={cx(styles.arrow, styles.arrow__right)}>
                <NavigationArrow type='right' handleClick={handleNextClick} disabled={isLastSlide} />
            </div>
        </div>
    )
}

ConstructCarousel.propTypes = {
    buildings: PropTypes.arrayOf(PropTypes.object).isRequired,
    onItemClick: PropTypes.func.isRequired,
    onItemHover: PropTypes.func.isRequired,
    selectedBuildingIdx: PropTypes.number.isRequired,
}

export default ConstructCarousel



// WEBPACK FOOTER //
// ./containers/Construct/components/ConstructCarousel/ConstructCarousel.jsx